<template>
  <div class="container sidebar">
    <div class="header bottom-shadow">
      <label>My Routes</label>
    </div>
    <div class="logininfo-header">
      <label>{{currentUserEmail}}</label>
      <label class="logout" v-on:click="logout()">Log out</label>
      </div>


    <div class="loader-container">
      <div class="loader" v-bind:class="{ 'loader-hide' : racesLoaded() }"></div>
    </div>

    <div class="route-list">
      <div v-if="racesLoaded() && !racesEmpty()">
        <div class="race-row" v-for="(race, key) in validRaces" v-if="race.publicId" :key="key" v-on:click="raceClicked(race)">

          <div class="length" v-bind:class="{'old-race': isOldRace(race.event.start)}">
            <label>{{ race.length | decimal }}</label>
          </div>

          <div class="info">
            <label class="name mobile">{{ textTruncate(race.event.name, 30) }}</label>
            <label class="name desktop">{{ textTruncate(race.event.name, 22) }}</label>
            <label class="start">{{ formatStart(race.event.start)}}</label>
          </div>

          <div class="loader race-loader" v-bind:class="{ 'loader-hide' : (loadingRace != race.publicId) }"></div>

        </div>
      </div>
    </div>
          <div v-if="racesLoaded() && racesEmpty()" class="no-routes-notice">
        <label style="text-align:center;">No routes here...yet!<br>Click the plus sign and create one!</label>
      </div>


    <BottomNav @nextPage="nextPage()" nText="+ Add new" nColor="blue" done="true" />
  </div>

</template>

<script>

import BottomNav from './BottomNav'
import { store } from '../store/store'
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import { racePepsRef } from '../firebase'
import firebase from 'firebase'
import VueTruncate from 'vue-truncate-filter'
import Vue from 'vue/dist/vue.js'
import { userRef } from '../firebase'

Vue.use(VueTruncate)

const decimalFilter = function(value) {
  return (value/1000).toFixed(1)
}

export default {
  name: 'myRaces',
  title: 'Runner - My Routes',
  filters: {
    decimal: decimalFilter
  },
  created() {
    this.$store.dispatch('setRacesRef', userRef.child(firebase.auth().currentUser.uid).child('races'))
   },
  components: {
   BottomNav
  },
  computed: {
    ...mapGetters(['races']),
    currentUserEmail() {
      return firebase.auth().currentUser.email
    },
    validRaces() { //The .key value in the race object made an empty row, this spagetti code will fix the problem :)
      if(this.races) {
        var array = this.races
        delete array['.key']
        return _.orderBy(array, 'event.start', 'desc')
      }
      return
    },
  },
  data() {
    return {
      loadingRace: null
    }
  },
  methods: {
    textTruncate(str, length) {
      if (length == null) {
        length = 100;
      }

      var ending = '...'

      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending
      } else {
        return str
      }
    },
    nextPage() {
     this.$router.replace('menu')
   },
   isOldRace(time) {
    try {
      const start = moment(time * 1000)
      const now = moment()
      return now.isAfter(start)
    } catch (err) {
     return false
    }
   },
   formatStart(time) {
     return moment(time * 1000).format('D MMM YYYY')
   },
   racesEmpty() {

     let returnable = true

     const racesKeys = Object.keys(this.races)
     racesKeys.forEach(key => {
       if (key !== '.key' && key !== '.value') {
         returnable = false
       }
     })
     return returnable
   },
   racesLoaded() {
     const keys = Object.keys(this.races).length

      if (keys === 0) {
       return false
     } else {
       return true
     }
   },
   raceClicked(race) {
     if(!this.loadingRace) {
       this.loadingRace = race.publicId
              if (race.hasOwnProperty('noPath')) {
              this.$store.dispatch('updateIsDistance', true)
              } else {
              this.$store.dispatch('updateIsDistance', false)

              }
       this.$store.dispatch('setRaceRef', {'ref': racePepsRef.child(race.publicId), 'myRaces': true }).then(() => {
         this.$store.dispatch('initInformation').then(() => {
           console.log("Information loading is done. routing to myracesinformation")
           this.loadingRace = null
           this.$router.replace('myracesinformation')
         })
       }).catch((err) => {
         this.loadingRace = null;
         alert("Unable to select race. If the race was created before 26.1.2019, it cannot be viewed in My Races.")
       })
     }
   },
   logout() {
      firebase.auth().signOut().then(() => {
        console.log("Logging out")
        this.$router.replace('login')
      })
    },
  }
 }
</script>

<style lang="scss" scoped>
  @import '../styles/styles.scss';

  .route-list {
	   overflow-y: auto;
	   overflow-x: hidden;
     height: calc(100% - 100px);
   }

   .container {
     justify-content: flex-start;
   }

  .container.sidebar {
    background-color: #F2F2F2;
  }

  .race-row {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    height: 80px;
    padding: 20px 10px;
    border-bottom: solid 1px gray;
    cursor: pointer;
  }

  .header {
    height: 80px;
  }

  .info {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 17px;

    .start {
      margin-top: 3px;
      opacity: 0.5;
      font-size: $font-medium;
    }

    label {
      cursor: pointer;
    }
  }

  .length {
    border-radius: 50%;
	  width: 48px;
	  height: 48px;
    background-color:#a8c545;
    display: flex;
    align-self: center;
    justify-content: center;
    color: white;
    align-items: center;
    font-size: $font-semiSemiLarge;
    margin-right: 20px;
    cursor: pointer;

    label {
      cursor: pointer;
    }
  }

  .old-race {
    background-color: $greyest;
  }

  .race-loader {
      padding: 8px;
      margin-top: 0px;
      align-self: center;
  }

  .name.desktop {
    display: none;
  }

  @media screen and (min-width: 1140px) {
    .name.desktop {
      display: block;
    }
    .name.mobile {
      display: none;
    }
  }

</style>
